import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/admin/Login';
import AdminLayout from './pages/admin/Layout';
import Dashboard from './pages/admin/Dashboard';
import Owners from './pages/admin/Owners';
import OwnerDetail from './pages/admin/OwnerDetail';
import Clients from './pages/admin/Clients';
import ClientDetail from './pages/admin/ClientDetail';
import Requests from './pages/admin/Requests';
import RequestDetail from './pages/admin/RequestDetail';
import ChangePassword from './pages/admin/ChangePassword';
import Vilkar from './pages/admin/Vilkar';
import Checkout from './pages/checkout/Checkout';
import Terms from './pages/checkout/Terms';

export default function App() {
  return (
    <Routes>
      {/* Offentlig: betalingsside og salgsvilkår */}
      <Route path="/c/:token" element={<Checkout />} />
      <Route path="/vilkar" element={<Terms />} />
      <Route path="/vilkar/:ownerId" element={<Terms />} />

      {/* Admin */}
      <Route path="/admin/login" element={<Login />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<Dashboard />} />
        <Route path="owners" element={<Owners />} />
        <Route path="owners/:id" element={<OwnerDetail />} />
        <Route path="clients" element={<Clients />} />
        <Route path="clients/:id" element={<ClientDetail />} />
        <Route path="requests" element={<Requests />} />
        <Route path="requests/:id" element={<RequestDetail />} />
        <Route path="vilkar" element={<Vilkar />} />
        <Route path="profil" element={<ChangePassword />} />
      </Route>

      <Route path="/" element={<Navigate to="/admin" replace />} />
    </Routes>
  );
}
